/**
 * The team invitation token, parked while the invitee signs in or signs up.
 *
 * An invitation link lands on /team/join?token=…, but a brand-new person has to
 * create an account first — and that round trip would otherwise lose the token
 * and send them back to their inbox to click the link again. Login and
 * registration check this on their way out and return the person to the join
 * page instead of the dashboard.
 */

const KEY = 'facewise.pendingTeamInvite'

export function rememberPendingInvite(token: string): void {
  try {
    sessionStorage.setItem(KEY, token)
  } catch {
    /* private mode / storage disabled — the join link still works, just not the round trip */
  }
}

export function takePendingInvite(): string | null {
  try {
    const token = sessionStorage.getItem(KEY)
    if (token) sessionStorage.removeItem(KEY)
    return token
  } catch {
    return null
  }
}

export function pendingInviteRoute(token: string): string {
  return `/team/join?token=${encodeURIComponent(token)}`
}
